<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentMember /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentMember from '@/components/team/dashboard/modules/users/member/ContentMember.vue'

export default 
{
  name: 'Member',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentMember
  }
}
</script>
<style>

</style>